import type { MouseEvent } from "react";

/**
 * Put on the element that holds a row menu inside a selectable `SkyDataGrid` row.
 *
 * The grid's row toggles its selection on any click that is not on a button, link or input. A
 * `SkyMenu` renders its items in a portal, and React bubbles a portal's click up the component
 * tree, so choosing an item (a pointer click, or Enter, which the menu turns into a click)
 * reached the row and ticked its checkbox (2026-09-29, the connections list). Stopping the click
 * here, below the row and above the menu, keeps the item's own action and drops the toggle.
 */
export function stopRowSelection(event: MouseEvent): void {
  event.stopPropagation();
}
